export const SERVICES = [
  {
    slug: "full-service-residential-interiors",
    index: "01",
    title: "Full-Service Residential Interiors",
    summary:
      "A comprehensive design service covering concept, spatial planning, detailed design, specification, procurement, coordination and installation.",
    cardSummary:
      "A complete design service encompassing concept, spatial planning, detailed design, specification, procurement, coordination and installation.",
    detail:
      "We take a home from first conversation to final styling, holding the architectural, material and emotional threads together throughout. Our role is to protect the idea at every stage while coordinating the specialists who bring it into being.",
    includes: [
      "Initial briefing and project definition",
      "Concept design",
      "Space planning",
      "Interior architecture",
      "Detailed design and technical information",
      "Lighting and electrical coordination",
      "Materials and finishes",
      "Bespoke joinery",
      "Kitchen and bathroom design",
      "Furniture, lighting and art",
      "Procurement",
      "Contractor and consultant coordination",
      "Installation and final styling",
    ],
  },
  {
    slug: "interior-architecture-renovation",
    index: "02",
    title: "Interior Architecture & Renovation",
    summary:
      "Thoughtful transformation of existing homes through layout, architectural detailing, lighting, material selection, bespoke joinery and technical coordination.",
    cardSummary:
      "The thoughtful transformation of existing homes through planning, architectural detailing, lighting, materials, bespoke joinery and technical coordination.",
    detail:
      "We study a property's existing character before proposing change, introducing new interventions with clarity. Where regulated architectural, structural or construction expertise is required, we coordinate appropriate consultants and contractors rather than providing those services directly.",
    includes: [
      "Existing-property assessment",
      "Layout studies",
      "Planning and listed-building considerations, where relevant",
      "Coordination with architects, engineers and specialist consultants",
      "Architectural details",
      "Bespoke joinery",
      "Lighting integration",
      "Material junctions and technical detailing",
      "Site-stage design support",
    ],
  },
  {
    slug: "styling-art-ffe",
    index: "03",
    title: "Styling, Art & FF&E",
    summary:
      "Furniture, lighting, textiles, art and objects brought together to give a home depth, identity and a sense of completion.",
    cardSummary:
      "Furniture, lighting, textiles, art and objects selected and composed to give a home depth, identity and a sense of completion.",
    detail:
      "Whether as the final layer of a larger project or as a standalone commission, we curate the pieces that give a home its character — sourcing, commissioning and placing each with intent.",
    includes: [
      "Furniture planning",
      "Sourcing and specification",
      "Bespoke pieces",
      "Decorative lighting",
      "Window treatments and textiles",
      "Art consultation and placement",
      "Accessories and objects",
      "Procurement and installation",
      "Final styling",
    ],
  },
];

export const HOW_WE_WORK = [
  { n: "01", title: "Discovery", text: "We listen closely — to the property, the people who will live in it and the ambitions behind the work." },
  { n: "02", title: "Concept", text: "We establish the architectural and material idea that will guide every subsequent decision." },
  { n: "03", title: "Development", text: "We resolve the design in detail, coordinating consultants, joinery, lighting and finishes." },
  { n: "04", title: "Realisation", text: "We oversee procurement, installation and final styling until the home is complete." },
];

export const APPROACH = [
  { n: "01", title: "Discover", text: "Understanding the property, its context and the lives it will hold." },
  { n: "02", title: "Define", text: "Setting the architectural and material intent that shapes the whole." },
  { n: "03", title: "Develop", text: "Resolving proportion, detail, light and craft with precision." },
  { n: "04", title: "Deliver", text: "Coordinating, installing and styling until the home feels complete." },
];

export const FAQS = [
  {
    q: "What size of project does the studio undertake?",
    a: "Full-service commissions are best suited to substantial renovations, whole-home projects and interiors requiring coordinated architectural, technical and decorative design. Styling, art and FF&E may also be commissioned separately for individual rooms or completed properties.",
  },
  {
    q: "At what stage should a client appoint the studio?",
    a: "Ideally, Arc & Hollow should be appointed before layouts, lighting or major architectural decisions are fixed. Early involvement allows the interior architecture, services, materials and furniture to be developed as one coherent design.",
  },
  {
    q: "Does the studio work outside London?",
    a: "Yes. The studio is based in London and considers projects elsewhere in the United Kingdom and internationally, subject to the scope, programme and travel requirements.",
  },
  {
    q: "Can the studio manage procurement?",
    a: "Yes. Procurement can include quotations, ordering, supplier coordination, delivery planning, installation and final styling, depending on the agreed scope.",
  },
  {
    q: "Does the studio work with a client's existing architect or contractor?",
    a: "Yes. Arc & Hollow can collaborate with an existing professional team or assist in assembling the consultants, contractors and craftspeople required for the project.",
  },
  {
    q: "How are design fees structured?",
    a: "Fees are tailored to the scope, scale and complexity of each commission. Following an initial conversation and review of the available information, the studio provides a clear written proposal setting out the services, deliverables and fee structure.",
  },
];
